import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { Form } from "../../../base/views/useForm";

const useStyles = makeStyles((theme) => ({
  Appcss: {
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(6px)",
    borderRadius: "15px",
    padding: "30px",
    justifyContent: "center",
    alignItems: "center",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(1, 0, 1),
  },
}));

const initialFValues = {
  barcode: "",
  ndc: "",
  name: "",
  strength: "",
  dosageform: "",
  packsize: "",
  upc: "",
};

export default function GoodReceivablePhysicalInventoryForm(props) {
  const classes = useStyles();
  const [errors, setErrors] = React.useState({});
  const [addPhysicalInventoryData, setState] = useState(initialFValues);

  const {
    addOrEdit,
    recordForEdit,
    addPhysicalInventory,
    captureGoodsState,
  } = props;

  const validate = (fieldValues = addPhysicalInventoryData) => {
    let temp = { ...errors };

    if ("packsize" in fieldValues) {
      temp.packsize =
        fieldValues.packsize === "" ? "Pack size is required" : "";
    }

    if ("ndc" in fieldValues) {
      temp.ndc =
        fieldValues.ndc.length < 11
          ? "Invalid NDC min. 11 characters required"
          : fieldValues.ndc.length > 15
          ? "NDC Maximum length exceeded"
          : "";
    }

    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      addPhysicalInventory({
        ...addPhysicalInventoryData,
        captureGoodsState: captureGoodsState,
      });
      addOrEdit(resetForm);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setState({
      ...addPhysicalInventoryData,
      [name]: value,
    });
  };

  const resetForm = () => {
    setState(initialFValues);
    setErrors({});
  };

  useEffect(() => {
    if (recordForEdit != null)
      setState({
        ...recordForEdit,
      });
  }, [recordForEdit]);

  return (
    <Form onSubmit={handleSubmit}>
      <Container component="main" maxWidth="sm">
        <div className={classes.form}>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <TextField
                value={addPhysicalInventoryData.barcode}
                onChange={handleInputChange}
                variant="outlined"
                required
                fullWidth
                id="barcode"
                label="Barcode"
                name="barcode"
                autoComplete="barcode"
                disabled
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={addPhysicalInventoryData.upc}
                onChange={handleInputChange}
                variant="outlined"
                required
                fullWidth
                id="upc"
                label="Upc"
                name="upc"
                autoComplete="upc"
                disabled
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                autoFocus
                value={addPhysicalInventoryData.ndc}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                id="ndc"
                label="NDC"
                name="ndc"
                autoComplete="ndc"
                {...(errors.ndc && {
                  error: true,
                  helperText: errors.ndc,
                })}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={addPhysicalInventoryData.name}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                id="name"
                label="Name"
                name="name"
                autoComplete="name"
                {...(errors.name && {
                  error: true,
                  helperText: errors.name,
                })}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={addPhysicalInventoryData.strength}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                id="strength"
                label="Strength"
                name="strength"
                autoComplete="strength"
                {...(errors.strength && {
                  error: true,
                  helperText: errors.strength,
                })}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={addPhysicalInventoryData.dosageform}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                id="dosageform"
                label="Dosage Form"
                name="dosageform"
                autoComplete="dosageform"
                {...(errors.dosageform && {
                  error: true,
                  helperText: errors.dosageform,
                })}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={addPhysicalInventoryData.packsize}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                id="packsize"
                label="Pack Size"
                name="packsize"
                autoComplete="packsize"
                InputProps={{ inputProps: { min: 1 } }}
                type="number"
                {...(errors.packsize && {
                  error: true,
                  helperText: errors.packsize,
                })}
              />
            </Grid>
            <Grid item xs={12}>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  style={{
                    width: "20vw",
                    backgroundColor: "rgb(22, 177, 255)",
                    borderRadius: "0.5rem",
                  }}
                  type="submit"
                >
                  Save
                </Button>
              </div>
            </Grid>
          </Grid>
        </div>
      </Container>
    </Form>
  );
}
